import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import { CardV2, Icon, LoadingSpinner } from 'pepsico-ds';
import { FetchYourCategoryForumUserCalendarAction } from '../../redux/action/CategoryForumAction';

const FORUM_TYPE_COLORS = {
    'CONTRACT BOARD': '#FCAC4B',
    'STRATEGY COUNCIL': '#60A3FC',
};

// Mock list of forums assigned to the logged-in user. Replace with API data once available.
// const yourForumsList = [
//     { id: 1, dateSubCategory: '10 Mar-2026-Corrugated', outcomesStatus: 'CONTRACT BOARD', sector: 'North America APAC' },
//     { id: 2, dateSubCategory: '10 Mar-2026-Corrugated', outcomesStatus: 'STRATEGY COUNCIL', sector: 'North America APAC' },
//     { id: 3, dateSubCategory: '20 Mar-2026-MRO & Facilities', outcomesStatus: 'CONTRACT BOARD', sector: 'North America APAC' },
//     { id: 4, dateSubCategory: '15 Mar-2026-Marketing Services', outcomesStatus: 'CONTRACT BOARD', sector: 'North America APAC' },
//     { id: 5, dateSubCategory: '16 Mar-2026-Marketing Services', outcomesStatus: 'CONTRACT BOARD', sector: 'North America APAC' },
//     { id: 6, dateSubCategory: '16 Mar-2026-PET', outcomesStatus: 'CONTRACT BOARD', sector: 'North America APAC' },
// ];

// const forumStatusById = {
//     1: { presentationStatus: 'Uploaded', actionItemStatus: 'Not Uploaded', outcomesStatus: 'In Progress' },
//     2: { presentationStatus: 'Not Uploaded', actionItemStatus: 'Not Uploaded', outcomesStatus: 'Not Started' },
//     3: { presentationStatus: 'Uploaded', actionItemStatus: 'Uploaded', outcomesStatus: 'Completed' },
//     4: { presentationStatus: 'Not Uploaded', actionItemStatus: 'Not Uploaded', outcomesStatus: 'Not Started' },
//     5: { presentationStatus: 'Uploaded', actionItemStatus: 'Not Uploaded', outcomesStatus: 'In Progress' },
//     6: { presentationStatus: 'Uploaded', actionItemStatus: 'Uploaded', outcomesStatus: 'In Progress' },
// };

// const STATUS_STYLES = {
//     'Uploaded': { background: '#DFF8DC', color: '#1D6B1D' },
//     'Not Uploaded': { background: '#EFEFEF', color: '#4B4B4B' },
//     'In Progress': { background: '#FEECD6', color: '#B15C0B' },
//     'Completed': { background: '#DFF8DC', color: '#1D6B1D' },
//     'Not Started': { background: '#EFEFEF', color: '#4B4B4B' },
// };

const STATUS_STYLES = {
    'Uploaded': {
        background: '#98E492',
        color: '#000000',
    },
    'Not Uploaded': {
        background: '#CDCDCD',
        color: '#000000',
    },
    'Documented': {
        background: '#E9CD2C',
        color: '#000000',
    },
    'Completed': {
        background: '#B0D0FB',
        color: '#000000',
    },
    'Partially Completed': {
        background: '#98E492',
        color: '#000000',
    },
    'No Action Items': {
        background: '#CDCDCD',
        color: '#000000',
    },
    'In-progress': {
        background: '#E9CD2C',
        color: '#000000',
    },
    'Not Started': {
        background: '#CDCDCD',
        color: '#000000',
    },
};


function StatusBadge({ label, value }) {
    const style = STATUS_STYLES[value] || STATUS_STYLES['Not Uploaded'];
    return (
        <div className="ycf-status-item">
            <span className="ycf-status-label">{label}:</span>
            {value && <span className="ycf-status-pill" style={{ background: style.background, color: style.color }}>{value}</span>}
        </div>
    );
}

function YourCategoryForums({ categoryForumConfig }) {


//     const forumSteps = [
//     {
//         id: 1,
//         title: 'Step 1:\nPrepare for the Forum',
//         description: 'Prepare for your Contract Board Meeting by understanding the Presentation requirements and Approval Matrix.',
//         bullets: [],
//         actions: [
//             {
//                 title: 'Schedule of Authority (SOA) & Approval Matrix',
//                 description: 'Understand approval requirements, thresholds\nand guidelines.',
//                 buttonText: 'View SOA & Approval Matrix',
//                 link: categoryForumConfig?.contractBoard?.planForum?.inviteApprovalMatrix,
//                 icon: 'arrow_forward',
//             },
//             {
//                 title: 'Contract Board Presentation Guidance',
//                 description: 'Review requirements for preparing your presentation.',
//                 buttonText: 'Download Presentation Guidance',
//                 link: categoryForumConfig?.contractBoard?.planForum?.downloadTemplateDeck,
//                 icon: 'download',
//             },
//             {
//                 title: 'Contract Board SharePoint',
//                 description: 'Access and manage documents for your Contract Board.',
//                 buttonText: 'Open SharePoint Folder',
//                 icon: 'arrow_forward',
//                 highlight: true,
//             },
//         ],
//     },
//     {
//         id: 2,
//         title: 'Step 2:\nUpload your Presentation',
//         description: 'Upload your <b>presentation</b> and supporting data (if required) to your <b>Contract Board SharePoint</b> folder below.',
//         bullets: [
//             {
//                 parts: [
//                     { text: 'Please name your file using the format ', bold: false },
//                     { text: '[Filetype]-[Date]-[Sector]-[Presenter(s)]', bold: true },
//                     { text: ' (e.g., \u201CPresentation-05-2026-APAC-Sarah Chen\u201D) to ensure it is correctly categorized.', bold: false },
//                 ],
//             },
//             {
//                 parts: [
//                     { text: 'If you have any concerns, please reach out to ', bold: false },
//                     { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
//                     { text: ', ', bold: false },
//                     { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
//                     { text: ', ', bold: false },
//                     { text: 'Rajeet.Sengupta@pepsico.com', href: 'mailto:Rajeet.Sengupta@pepsico.com' },
//                 ],
//             },
//         ],
//         actions: [
//             {
//                 title: 'Contract Board SharePoint Folder',
//                 description: 'Access and manage documents for your Contract Board.',
//                 buttonText: 'Open SharePoint Folder',
//                 icon: 'arrow_forward',
//                 highlight: true,
//             },
//         ],
//     },
//     {
//         id: 3,
//         title: 'Post-forum\nExecutive Summary',
//         // adminOnly: true,
//         description: 'After your <b>Contract Board Meeting</b> is conducted, the <b>Admin</b> will document key decisions, risks, and next steps in the <b>Executive Summary</b> and will share it with all the<br/> attendees of the forum via <b>email</b> within a week of conducting the Forum.',
//         bullets: [
//             {
//                 parts: [
//                     { text: 'If you have any concerns, please reach out to ', bold: false },
//                     { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
//                     { text: ', ', bold: false },
//                     { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
//                     { text: ', ', bold: false },
//                     { text: 'Rajeet.Sengupta@pepsico.com', href: 'mailto:Rajeet.Sengupta@pepsico.com' },
//                 ],
//             },
//         ],
//     },
//     {
//         id: 4,
//         title: 'Step 3:\nReview Action Items',
//         description: 'Review the status of action items decided during your Contract Board Meeting.',
//         bullets: [
//             'Click on <b>Open Action Items Tracker</b> to review the action items against your Contract Board forum.',
//             {
//                 italic: true,
//                 parts: [
//                     { text: 'Reach out to ', bold: false },
//                     { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
//                     { text: ', ', bold: false },
//                     { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
//                     { text: ' or ', bold: false },
//                     { text: 'Rajeet.Sengupta@pepsico.com', href: 'mailto:Rajeet.Sengupta@pepsico.com' },
//                     { text: ' to update/modify your action items, if required.', bold: false },
//                 ],
//             },
//         ],
//         actions: [
//             {
//                 title: 'Action Items Tracker',
//                 description: 'Review and track action items from your Contract Board meeting.',
//                 buttonText: 'Open Action Items Tracker',
//                 link: categoryForumConfig?.contractBoard?.actionItemsTracking?.goToSharepoint,
//                 icon: 'arrow_forward',
//             },
//             {
//                 title: 'Contract Board SharePoint Folder',
//                 description: 'Access and manage documents for your Contract Board.',
//                 buttonText: 'Open SharePoint Folder',
//                 icon: 'arrow_forward',
//                 highlight: true,
//             },
//         ],
//     },
//     {
//         id: 5,
//         title: 'Step 4:\nCategory Outcomes Tracking',
//         description: 'Track and update your Contract Board outcomes over the next 3-6 months, including execution, achievement, risks, and follow-through.',
//         bullets: [
//             'Review the <b>Outcomes Tracking Guidance</b> to understand the Outcomes Tracking process.',
//             'Refer to the <b>Sample Outcomes Tracking File</b> to know how to document your Category Outcomes.',
//             'Update the Category Outcomes for your Contract on the <b>Category Outcomes Tracking Excel file</b> (when available).',
//             '<i>If some of the outcomes for your Contract Board are not mentioned, please mention those outcomes in the Unique Elements category.</i>',
//             {
//                 parts: [
//                     { text: 'Reach out to ', bold: false },
//                     { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
//                     { text: ', ', bold: false },
//                     { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
//                     { text: ', ', bold: false },
//                     { text: 'Rajeet.Sengupta@pepsico.com', href: 'mailto:Rajeet.Sengupta@pepsico.com' },
//                     { text: ' to update/modify your action items, if required.', bold: false },
//                 ],
//             },
//         ],
//         actions: [
//             {
//                 title: 'Outcomes Tracking Guidance',
//                 description: 'Understand the process and requirements for tracking outcomes.',
//                 buttonText: 'Download Outcomes Tracking Guidance',
//                 link: categoryForumConfig?.contractBoard?.trackOutcomes?.downloadTemplate,
//                 icon: 'download',
//             },
//             {
//                 title: 'Sample Outcomes Tracking File',
//                 description: 'Use the sample file as a reference for recording outcomes.',
//                 buttonText: 'Download Sample File',
//                 link: categoryForumConfig?.contractBoard?.trackOutcomes?.sampleFile,
//                 icon: 'download',
//             },
//             ...(yourCategoryForumUserCalendarData?.forums?.outcomesSummaryUrl !== null
//                 ? 
//                     [
//                         {
//                             title: 'Contract Board SharePoint Folder',
//                             description: 'Access and manage documents for your Contract Board.',
//                             buttonText: 'Open SharePoint Folder',
//                             icon: 'arrow_forward',
//                             highlight: true,
//                         },
//                     ]
//                 : []),
//             {
//                 title: 'Contract Board SharePoint Folder',
//                 description: 'Access and manage documents for your Contract Board.',
//                 buttonText: 'Open SharePoint Folder',
//                 icon: 'arrow_forward',
//                 highlight: true,
//             },
//         ],
//     },
// ];


    // let forumSteps = []

    const [forumSteps, setForumSteps] = useState([]);


    const [yourForumsList, setYourForumsList] = useState([]);
    const [forumStatusById, setForumStatusById] = useState({});
    const [selectedForumId, setSelectedForumId] = useState(1);
    const [selectedStepId, setSelectedStepId] = useState(1);

    const [isDataLoading, setIsDataLoading] = useState(true);


    const selectedForum = yourForumsList.find((forum) => forum.id === selectedForumId) || yourForumsList[0];
    const selectedForumStatus = forumStatusById[selectedForumId] || {};
    // let currentStepData = {};
    const [currentStepData, setCurrentStepData] = useState({});
    

    const dispatch = useDispatch();

    const userData = useSelector((state) => state.getLandingPageReducer);
    const yourCategoryForumUserCalendarData = useSelector((state) => state.getYourCategoryForumUserCalendarReducer);

    // const categoryForumConfig = useSelector((state) => state.getCategoryForumConfigReducer);

    useEffect(() => {
        if (userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {
            let req = {
                "email": userData?.emailId
            }
            dispatch(FetchYourCategoryForumUserCalendarAction(req));
        }
    }, [userData]);


    useEffect(() => {
        if (yourCategoryForumUserCalendarData && yourCategoryForumUserCalendarData.type === "SUCCESS_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION") {
            // Handle the successful fetch of your category forum user calendar data here
            const yourForumsListValue = yourCategoryForumUserCalendarData?.forums.map((item, index) => ({
                id: index + 1,
                dateSubCategory: item.dateSubCategory,
                typeOfForum: item.typeOfForum?.toUpperCase(),
                sector: item.sector,
                folderUrl: item.folderUrl,
                outcomesSummaryUrl: item.outcomesSummaryUrl,
            }));

            const forumStatusByIdValue = yourCategoryForumUserCalendarData?.forums.reduce((acc, item, index) => {
                const id = index + 1;

                acc[id] = {
                    presentationStatus: item.presentationStatus,
                    actionItemStatus: item.actionItemStatus,
                    outcomesStatus: item.outcomesStatus,
                };

                return acc;
            }, {});

                setYourForumsList(yourForumsListValue);
                setForumStatusById(forumStatusByIdValue);

                  setForumSteps([
                    {
                        id: 1,
                        title: 'Step 1:\nPrepare for the Forum',
                        description: 'Prepare for your Contract Board Meeting by understanding the Presentation requirements and Approval Matrix.',
                        bullets: [],
                        actions: [
                            {
                                title: 'Schedule of Authority (SOA) & Approval Matrix',
                                description: 'Understand approval requirements, thresholds\nand guidelines.',
                                buttonText: 'View SOA & Approval Matrix',
                                link: categoryForumConfig?.contractBoard?.planForum?.inviteApprovalMatrix,
                                icon: 'arrow_forward',
                            },
                            {
                                title: 'Contract Board Presentation Guidance',
                                description: 'Review requirements for preparing your presentation.',
                                buttonText: 'Download Presentation Guidance',
                                link: categoryForumConfig?.contractBoard?.planForum?.downloadTemplateDeck,
                                icon: 'download',
                            },
                            {
                                title: 'Contract Board SharePoint',
                                description: 'Access and manage documents for your Contract Board.',
                                buttonText: 'Open SharePoint Folder',
                                link: selectedForum?.folderUrl,
                                icon: 'arrow_forward',
                                highlight: true,
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: 'Step 2:\nUpload your Presentation',
                        description: 'Upload your <b>presentation</b> and supporting data (if required) to your <b>Contract Board SharePoint</b> folder below.',
                        bullets: [
                            {
                                parts: [
                                    { text: 'Please name your file using the format ', bold: false },
                                    { text: '[Filetype]-[Date]-[Sector]-[Presenter(s)]', bold: true },
                                    { text: ' (e.g., \u201CPresentation-28-Sep-2026-APAC-Sarah Chen\u201D) to ensure it is correctly categorized.', bold: false },
                                ],
                            },
                            {
                                italic: true,
                                parts: [
                                    { text: 'If you have any concerns, please reach out to ', bold: false },
                                    { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
                                    { text: ', ', bold: false },
                                    { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
                                    { text: ', ', bold: false },
                                    { text: 'rajeet.sengupta@pepsico.com', href: 'mailto:rajeet.sengupta@pepsico.com' },
                                ],
                            },
                        ],
                        actions: [
                            {
                                title: 'Contract Board SharePoint Folder',
                                description: 'Access and manage documents for your Contract Board.',
                                link: selectedForum?.folderUrl,
                                buttonText: 'Open SharePoint Folder',
                                icon: 'arrow_forward',
                                highlight: true,
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: 'Post-forum\nExecutive Summary',
                        // adminOnly: true,
                        description: 'After your <b>Contract Board Meeting</b> is conducted, the <b>Admin</b> will document key decisions, risks, and next steps in the <b>Executive Summary</b><br/>and will share it with all the attendees of the forum via <b>email</b> within a week of conducting the Forum.',
                        bullets: [
                            'The <b>Executive Summary</b> will also be available in your <b>Contract Board SharePoint Folder</b> for easy access at any time.',
                            {
                                italic: true,
                                parts: [
                                    { text: 'If you have any concerns, please reach out to ', bold: false },
                                    { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
                                    { text: ', ', bold: false },
                                    { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
                                    { text: ', ', bold: false },
                                    { text: 'rajeet.sengupta@pepsico.com', href: 'mailto:rajeet.sengupta@pepsico.com' },
                                ],
                            },
                        ],
                        actions: [
                            {
                                title: 'Contract Board SharePoint Folder',
                                description: 'Access and manage documents for your Contract Board.',
                                link: selectedForum?.folderUrl,
                                buttonText: 'Open SharePoint Folder',
                                icon: 'arrow_forward',
                                highlight: true,
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: 'Step 3:\nReview Action Items',
                        description: 'Review the status of action items decided during your Contract Board Meeting.',
                        bullets: [
                            'Click on <b>Open Action Items Tracker</b> to review the action items against your Contract Board forum.',
                            {
                                italic: true,
                                parts: [
                                    { text: 'Reach out to ', bold: false },
                                    { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
                                    { text: ', ', bold: false },
                                    { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
                                    { text: ' or ', bold: false },
                                    { text: 'rajeet.sengupta@pepsico.com', href: 'mailto:rajeet.sengupta@pepsico.com' },
                                    { text: ' to update/modify your action items, if required.', bold: false },
                                ],
                            },
                        ],
                        actions: [
                            {
                                title: 'Action Items Tracker',
                                description: 'Review and track action items from your Contract Board meeting.',
                                buttonText: 'Open Action Items Tracker',
                                link: categoryForumConfig?.contractBoard?.actionItemsTracking?.goToSharepoint,
                                icon: 'arrow_forward',
                            },
                            {
                                title: 'Contract Board SharePoint Folder',
                                description: 'Access and manage documents for your Contract Board.',
                                link: selectedForum?.folderUrl,
                                buttonText: 'Open SharePoint Folder',
                                icon: 'arrow_forward',
                                highlight: true,
                            },
                        ],
                    },
                    {
                        id: 5,
                        title: 'Step 4:\nCategory Outcomes Tracking',
                        description: 'Track and update your Contract Board outcomes over the next 3-6 months, including execution, achievement, risks, and follow-through.',
                        bullets: [
                            'Review the <b>Outcomes Tracking Guidance</b> to understand the Outcomes Tracking process.',
                            'Refer to the <b>Sample Outcomes Tracking File</b> to know how to document your Category Outcomes.',
                            'Update the Category Outcomes for your Contract on the <b>Category Outcomes Tracking Excel file</b> (when available)\n',
                            '',
                            '\n<i>If some of the outcomes for your Contract Board are not mentioned, please mention those outcomes in the Unique Elements category.</i>',
                            {
                                italic: true,
                                parts: [
                                    { text: 'Reach out to ', bold: false },
                                    { text: 'globalprocurementexcellence@pepsico.com', href: 'mailto:globalprocurementexcellence@pepsico.com' },
                                    { text: ', ', bold: false },
                                    { text: 'rachel.thomas@pepsico.com', href: 'mailto:rachel.thomas@pepsico.com' },
                                    { text: ', ', bold: false },
                                    { text: 'rajeet.sengupta@pepsico.com', href: 'mailto:rajeet.sengupta@pepsico.com' },
                                    { text: ' to update/modify your action items, if required.', bold: false },
                                ],
                            },
                        ],
                        actions: [
                            {
                                title: 'Outcomes Tracking Guidance',
                                description: 'Understand the process and requirements for tracking outcomes.',
                                buttonText: 'Download Outcomes Tracking Guidance',
                                link: categoryForumConfig?.contractBoard?.trackOutcomes?.downloadTemplate,
                                icon: 'download',
                            },
                            {
                                title: 'Sample Outcomes Tracking File',
                                description: 'Use the sample file as a reference for recording outcomes.',
                                buttonText: 'Download Sample File',
                                link: categoryForumConfig?.contractBoard?.trackOutcomes?.sampleFile,
                                icon: 'download',
                            },
                            {
                                title: 'Category Outcomes Tracking Excel File',
                                description: selectedForum?.outcomesSummaryUrl !== null ? 'Update outcomes for your Contract Board.' : 'Outcomes Tracking Excel file will be available once the Contract Board meeting is completed.',
                                buttonText: 'Open Outcomes Excel File',
                                link: selectedForum?.outcomesSummaryUrl,
                                icon: 'arrow_forward',
                            },
                            {
                                title: 'Contract Board SharePoint Folder',
                                description: 'Access and manage documents for your Contract Board.',
                                link: selectedForum?.folderUrl,
                                buttonText: 'Open SharePoint Folder',
                                icon: 'arrow_forward',
                                highlight: true,
                            },
                        ],
                    },
                ]);

                // currentStepData = forumSteps.find((step) => step.id === selectedStepId) || forumSteps[0];

                setIsDataLoading(false)
                
        }
    }, [yourCategoryForumUserCalendarData, selectedForumId, selectedForum?.folderUrl, selectedForum?.outcomesSummaryUrl, categoryForumConfig]);


    useEffect(() => {
        setCurrentStepData(forumSteps?.find((step) => step.id === selectedStepId) || forumSteps[0]);
    }, [forumSteps, selectedStepId]);

    return (
        <>
            
            <div className="your-category-forums-container">
            <div className="ycf-header-title">Your Category Forums</div>
            <div className="ycf-header-subtitle">Select a Category Forum to view its summary and open the workflow.</div>
            {
            isDataLoading ? (
                <>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '250px'}}>
                        <LoadingSpinner />
                    </div>
                    
                </>
            ) :(
                <Row gutter={[20, 20]} align="top">
                <Col xs={24} sm={24} md={7} lg={7} xl={6}>
                    <div className="ycf-forum-list">
                        {yourForumsList?.map((forum) => (
                            <div
                                key={forum.id}
                                className={`ycf-forum-list-item ${forum.id === selectedForumId ? 'ycf-forum-list-item-selected' : ''}`}
                                role="button"
                                tabIndex={0}
                                style={{ color: forum.id === selectedForumId ? '#002451' : '#656565' }}
                                onClick={() => setSelectedForumId(forum.id)}
                                onKeyDown={(e) => { if (e.key === 'Enter') setSelectedForumId(forum.id); }}
                            >
                                <div className="ycf-forum-list-item-title">{forum.dateSubCategory}</div>
                                <div className="ycf-forum-list-item-meta">
                                    <span className="ycf-forum-dot" style={{ background: FORUM_TYPE_COLORS[forum.typeOfForum] || '#B1B1B1' }} />
                                    <span className="ycf-forum-type" style={{ color: forum.id === selectedForumId ? '' : '#656565' }}>{forum.typeOfForum}</span>
                                </div>
                                <div className="ycf-forum-list-item-location">{forum.sector}</div>
                            </div>
                        ))}
                    </div>
                </Col>

                <Col xs={24} sm={24} md={17} lg={17} xl={18}>
                    <div className="ycf-detail-panel">
                        <div className="ycf-detail-title">{selectedForum?.dateSubCategory}</div>
                        <div className="ycf-detail-subrow">
                            <div className="ycf-detail-forum-type-col">
                                <div className="ycf-detail-forum-type">
                                    <span className="ycf-forum-dot" style={{ background: FORUM_TYPE_COLORS[selectedForum?.typeOfForum] || '#B1B1B1' }} />
                                    <span className="ycf-forum-type">{selectedForum?.typeOfForum}</span>
                                </div>
                                <span className="ycf-detail-location">{selectedForum?.sector}</span>
                            </div>
                            <div className="ycf-forum-status-group" style={{ marginLeft: '15rem' }}>
                                <span className="ycf-forum-status-label">FORUM STATUS</span>
                                <div className="ycf-forum-status-items">
                                    <StatusBadge label="Presentation" value={selectedForumStatus.presentationStatus} />
                                    <StatusBadge label="Action Items" value={selectedForumStatus.actionItemStatus} />
                                    <StatusBadge label="Outcomes" value={selectedForumStatus.outcomesStatus} />
                                </div>
                            </div>
                            {/* <div></div> */}
                        </div>

                        <div className="steps-navigation">
                            {forumSteps?.map((step) => {
                                const [stepLine1, stepLine2] = step.title.split('\n');
                                return selectedStepId === step.id ? (
                                    <button key={step.id} type="button" className="ycf-step-active" disabled>
                                        <span className="ycf-step-line1">{stepLine1}</span>
                                        {stepLine2 && <span className="ycf-step-line2">{stepLine2}</span>}
                                    </button>
                                ) : (
                                    <span
                                        key={step.id}
                                        className="step-text-link"
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => setSelectedStepId(step.id)}
                                        onKeyDown={(e) => { if (e.key === 'Enter') setSelectedStepId(step.id); }}
                                    >
                                        <span className="ycf-step-line1">{stepLine1}</span>
                                        {stepLine2 && <span className="ycf-step-line2">{stepLine2}</span>}
                                    </span>
                                );
                            })}
                        </div>

                        {/* <CardV2
                            className="step-detail-card"
                            state="non-interactive"
                            type="basic"
                            nested={true}
                            cardBody={{
                                type: 'slot',
                                slot: ( */}
                                    <div className="step-detail-content" style={{padding: '20px 0' }}>
                                        {/* <div className="step-detail-header">
                                            <Icon icon="calendar_today" size="medium" style={{ color: '#FCAC4B' }} />
                                            <span className="step-detail-title">{currentStepData.title}</span>
                                            {currentStepData.adminOnly && (
                                                <span className="admin-only-badge">Admin Only</span>
                                            )}
                                        </div> */}
                                        <p className="step-detail-description" dangerouslySetInnerHTML={{ __html: currentStepData?.description }} />
                                        <ul className="step-detail-bullets">
                                            {currentStepData  && currentStepData.bullets?.map((bullet, index) => (
                                                <>
                                                {bullet.length == 0 ? (
                                                    <><br/></>
                                                ) : (
                                                    <>
                                                        <li key={index} style={typeof bullet === 'object' && bullet.italic ? { fontStyle: 'italic' } : undefined}>
                                                            {typeof bullet === 'object' && bullet.parts
                                                                ? bullet?.parts?.map((part, i) => (
                                                                    part.href
                                                                        ? (
                                                                            <a key={i} href={part.href} style={{ color: '#005cbc', textDecoration: 'none', fontWeight: part.bold ? 700 : undefined }}>
                                                                                {part.text}
                                                                            </a>
                                                                        )
                                                                        : <span key={i} style={part.bold ? { fontWeight: 700 } : undefined}>{part.text}</span>
                                                                ))
                                                                : <span dangerouslySetInnerHTML={{ __html: bullet }} />
                                                            }
                                                        </li>
                                                    </>
                                                )
                                                }
                                                </>
                                            ))}
                                        </ul>
                                        {currentStepData && currentStepData.actions?.length > 0 && (
                                            <Row gutter={[16, 16]} className="step-action-cards-row">
                                                {currentStepData && currentStepData.actions?.map((action, index) => (
                                                    <Col
                                                        key={index}
                                                        xs={24}
                                                        sm={24}
                                                        md={currentStepData && currentStepData.actions.length === 1 ? 24 : currentStepData && currentStepData.actions.length === 2 ? 12 : 8}
                                                    >
                                                        <div className={`step-action-card${action.highlight ? ' step-action-card-highlight' : ''}`}>
                                                            <div className="step-action-card-title">{action.title}</div>
                                                            <div className="step-action-card-description">{action.description}</div>
                                                            {action.title === 'Category Outcomes Tracking Excel File' && selectedForum?.outcomesSummaryUrl === null ? (
                                                                <></>
                                                            ) : (
                                                                <>
                                                                    <button type="button" className="step-action-card-button" onClick={() => window.open(action.link, '_blank')}>
                                                                        {action.icon === 'download' && <Icon icon="download" size="small" />}
                                                                        <span>{action.buttonText}</span>
                                                                        {action.icon !== 'download' && <Icon icon="arrow_forward" size="small" />}
                                                                    </button>
                                                                </>
                                                            )}
                                                            
                                                        </div>
                                                    </Col>
                                                ))}
                                            </Row>
                                        )}
                                    </div>
                                {/* ),
                            }}
                        /> */}
                    </div>
                </Col>
            </Row>
            )
            }
            
        </div>

            
        
        </>
        
    );
}

export default YourCategoryForums;